import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)]" }
const _hoisted_2 = { class: "w-full fixed z-40 -mt-2 mb-8" }
const _hoisted_3 = { class: "min-h-screen" }

import { defineAsyncComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { DigiFooter } from '@digi-io/digi-ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const NavBar = defineAsyncComponent(() => import('./components/global/nav-bar.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));

const store = useStore();

const showSidebar = computed(() => store.state.sidebar);
const isLight = computed(() => store.state.theme.theme === 'light');

const currentYear = ref(new Date().getFullYear());

const toggleTheme = () => {
  store.dispatch('theme/toggleTheme');
  const newTheme = store.state.theme.theme;

  document.documentElement.classList.toggle('light', newTheme === 'light');
};

function clickOutside() {
  if (showSidebar.value) store.commit('toggleSidebar');
}

function toggleSidebar() {
  store.commit('toggleSidebar');
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Notifications)),
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-red-200 opacity-50 z-30",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_unref(NavBar)),
      _createVNode(_unref(Sidebar))
    ])), [
      [_directive_click_outside, clickOutside]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["pt-16", {
        'blocker': showSidebar.value,
      }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view)
      ])
    ], 2),
    _createVNode(_unref(DigiFooter), {
      isLight: isLight.value,
      isAuth: _ctx.isAuth,
      usersLink: `${_ctx.VUE_APP_DG_USERS_APP}`,
      showSidebar: showSidebar.value
    }, null, 8, ["isLight", "isAuth", "usersLink", "showSidebar"])
  ]))
}
}

})